module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(_vm.selectedAppointments.length > 0) ? _c('v-toolbar', {
    staticStyle: {
      "z-index": "15"
    },
    style: ({
      top: _vm.topOffset
    }),
    attrs: {
      "extended": "",
      "fixed": "",
      "dark": "",
      "flat": "",
      "top": "",
      "extension-height": "28",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": _vm.$vuetify.breakpoint.xs,
      "flat": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("deselect")
      }
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs-only"
  }, [_vm._v(" " + _vm._s(_vm.$t('buttons.deselect')))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "dark": "",
      "flat": "",
      "small": "",
      "outline": "",
      "disabled": _vm.permissionsCanBulkAddCodes === false
    },
    on: {
      "click": function($event) {
        _vm.codeTouch++;
        _vm.dialogs.codes = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('buttons.codes')) + "\n      ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "dark": "",
      "flat": "",
      "small": "",
      "outline": "",
      "disabled": (_vm.clientIds && _vm.clientIds.length > 1) || _vm.permissionsCanCreateInvoice === false
    },
    on: {
      "click": function($event) {
        return _vm.launchQuickInvoiceDialog(_vm.invoiceOptions)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('buttons.invoices')) + "\n      ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "dark": "",
      "flat": "",
      "small": "",
      "outline": "",
      "disabled": (_vm.clientIds && _vm.clientIds.length > 1) || (_vm.spaceIds && _vm.spaceIds.length > 1) || _vm.permissionsCanBulkAddPayment === false
    },
    on: {
      "click": function($event) {
        return _vm.launchAppointmentPaymentDialog(_vm.paymentOptions)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          " + _vm._s(_vm.$t('buttons.payments')) + "\n      ")], 1), _vm._v(" "), (_vm.selectedAppointments && _vm.selectedAppointments.length > 0) ? _c('template', {
    slot: "extension"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ma-0 pl-0 mr-2 mb-3 white--text",
          class: {
            "ml-0": _vm.$vuetify.breakpoint.xs,
            "ml-3": _vm.$vuetify.breakpoint.smAndUp
          },
          attrs: {
            "slot": "activator",
            "small": "",
            "flat": ""
          },
          slot: "activator"
        }, on), [_vm._v("\n                " + _vm._s(_vm.$tc('toolbar.extension', _vm.selectedAppointments.length, {
          n: _vm.selectedAppointments.length
        })) + "\n              "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 988659059)
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline py-0 grey lighten-4"
  }, [_vm._v("\n                Selected appointments\n\n              ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.selectedAppointments), function(appointment) {
    return _c('appointment-list-item', {
      key: appointment.id,
      attrs: {
        "with-tags": "",
        "with-action": false,
        "with-status-chips": "",
        "with-color-coding": false,
        "appointment": appointment
      }
    })
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.spaceIds && _vm.spaceIds.length > 0) ? _c('space-faces', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "space-ids": _vm.spaceIds
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mx-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('practitioner-faces', {
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "practitioner-ids": _vm.practitionerIds
    }
  })], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs
    },
    model: {
      value: (_vm.dialogs.codes),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "codes", $$v)
      },
      expression: "dialogs.codes"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": _vm.themeColor,
      "dense": "",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.codes')) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogs.codes = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('bulk-add-codes', {
    attrs: {
      "with-title": true,
      "with-done": true,
      "touch": _vm.codeTouch,
      "appointment-ids": _vm.selectedAppointmentIds
    },
    on: {
      "saved": function($event) {
        return _vm.$emit("codes:created")
      },
      "close": function($event) {
        _vm.dialogs.codes = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73f8d588","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statement/BulkActions.vue
// module id = 1469
// module chunks = 9